import moment from "moment";

export const siderHours = (time: string) => {
  return moment(time, "HH:mm")
    .subtract("hours", new Date().getTimezoneOffset() / 60)
    .format("HH:mm");
};
